import { MutableRefObject, useEffect, useState } from 'react';

type MouseCoordinates = {
    mouseClientX: number | null;
    mouseClientY: number | null;
};

export const useMouseClickPosition = (mapRef: MutableRefObject<HTMLDivElement | null>) => {
    const [mouseClickPosition, setMouseClickPosition] = useState<MouseCoordinates>({
        mouseClientX: null,
        mouseClientY: null,
    });

    useEffect(() => {
        const refCurrent = mapRef.current;

        if (!refCurrent) {
            return;
        }

        const updateMouseClickPosition = (mouseEvent: MouseEvent) => {
            setMouseClickPosition({
                mouseClientX: mouseEvent.clientX,
                mouseClientY: mouseEvent.clientY,
            });
        };

        refCurrent.addEventListener('mousedown', updateMouseClickPosition);

        return () => {
            refCurrent.removeEventListener('mousedown', updateMouseClickPosition);
        };
    }, [mapRef]);

    return mouseClickPosition;
};
